const styles = {
    content: {
      textAlign: 'center',
      padding: 10,
      color: 'grey'
    }
  };
export default styles;


// WEBPACK FOOTER //
// ./src/components/notAvailable/styles/NotAvailableStyles.js